export default __webpack_public_path__ + "static/media/HUSKY.8038cdd3.png";